(function () {
  "use strict";

  function updateCartCount(count) {
    document
      .querySelectorAll("[data-cart-count], .cart-count, #cart-count, .cart-count-bubble span, .cart-count-bubble")
      .forEach(function (el) {
        el.textContent = count;
        el.classList.add("cart-count-pop");

        setTimeout(function () {
          el.classList.remove("cart-count-pop");
        }, 450);
      });
  }

  function refreshCartCount() {
    return fetch("/cart.js")
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);

        if (typeof window.globalcartcountupdate === "function") {
          try {
            window.globalcartcountupdate();
          } catch (_) {}
        }

        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: { cart: cart }
          })
        );

        document.dispatchEvent(new CustomEvent("cart:refresh"));
        window.dispatchEvent(new CustomEvent("cart:refresh"));

        return cart;
      });
  }

  function getProtocolDays(chip) {
    if (!chip) return "";

    var explicitDays =
      chip.getAttribute("data-days") ||
      chip.getAttribute("data-number-of-days");

    if (explicitDays) return explicitDays;

    var daysEl = chip.querySelector(".pack-chip-days");
    return daysEl ? daysEl.textContent.replace("Days", "").trim() : "";
  }

  function buildCartButtonText(chip) {
    var days = getProtocolDays(chip);

    return days
      ? "Add to Cart — Start My " + days + "-Day Protocol →"
      : "Add to Cart";
  }

  function setPaymentButtonAvailability(paymentWrap, available) {
    if (!paymentWrap) return;

    var isAvailable = String(available) === "true" || available === true;

    paymentWrap.classList.toggle("is-sold-out", !isAvailable);

    paymentWrap
      .querySelectorAll("button, [role='button'], input[type='submit']")
      .forEach(function (btn) {
        if (isAvailable) {
          btn.removeAttribute("disabled");
          btn.style.pointerEvents = "";
          btn.style.opacity = "";
        } else {
          btn.setAttribute("disabled", "disabled");
          btn.style.pointerEvents = "none";
          btn.style.opacity = "0.45";
        }
      });
  }

  function getVariantInput(scope) {
    if (!scope) return null;

    return (
      scope.querySelector("[data-hero-variant-input]") ||
      scope.querySelector("[data-science-variant-input]") ||
      scope.querySelector("[data-pack-variant-input]") ||
      scope.querySelector("[data-gem-variant-input]") ||
      scope.querySelector("form[action*='/cart/add'] input[name='id']") ||
      scope.querySelector('form[action*="/cart/add"] input[name="id"]')
    );
  }

  function getPaymentWrap(scope) {
    if (!scope) return null;

    return (
      scope.querySelector("[data-hero-payment-wrap]") ||
      scope.querySelector("[data-science-payment-wrap]") ||
      scope.querySelector("[data-pack-payment-wrap]") ||
      scope.querySelector("[data-gem-payment-wrap]")
    );
  }

  function updatePaymentForm(scope, variantId, available) {
    var variantInput = getVariantInput(scope);
    var paymentWrap = getPaymentWrap(scope);

    if (variantInput && variantId) {
      variantInput.value = variantId;

      variantInput.dispatchEvent(
        new Event("change", {
          bubbles: true
        })
      );
    }

    setPaymentButtonAvailability(paymentWrap, available);
  }

  function addVariantToCart(variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: quantity || 1
      })
    }).then(function (res) {
      if (!res.ok) throw new Error("Cart add failed");
      return res.json();
    });
  }

  function selectHeroChip(chip) {
    if (!chip || chip.classList.contains("sold-out")) return;

    var section = chip.closest(".vitality-hero-v3");
    if (!section) return;

    var chips = section.querySelectorAll(".pack-chip");
    var price = section.querySelector("[data-hero-price]");
    var mrp = section.querySelector("[data-hero-mrp]");
    var off = section.querySelector("[data-hero-off]");
    var per = section.querySelector("[data-hero-per]");
    var cartBtn = section.querySelector("[data-hero-cart]");
    var buyNowBtn = section.querySelector("[data-hero-buy-now]");

    chips.forEach(function (el) {
      el.classList.remove("selected");
    });

    chip.classList.add("selected");

    var variantId = chip.getAttribute("data-variant-id");
    var available = chip.getAttribute("data-available") === "true";

    updatePaymentForm(section, variantId, available);

    if (price) {
      price.textContent = chip.getAttribute("data-price") || "";
    }

    if (mrp) {
      var chipMrp = chip.getAttribute("data-mrp");
      mrp.textContent = chipMrp && chipMrp !== "₹0" ? chipMrp : "";
    }

    if (off) {
      var chipDiscount = chip.getAttribute("data-discount");
      off.textContent =
        chipDiscount && chipDiscount !== "0% OFF" ? chipDiscount : "";
    }

    if (per) {
      per.textContent = chip.getAttribute("data-per-day") || "";
    }

    if (cartBtn) {
      cartBtn.dataset.selectedVariant = variantId;
      cartBtn.disabled = !available;
      cartBtn.classList.remove("is-added", "is-loading");
      cartBtn.textContent = available ? buildCartButtonText(chip) : "Sold Out";
    }

    if (buyNowBtn) {
      buyNowBtn.dataset.selectedVariant = variantId;
      buyNowBtn.disabled = !available;
    }
  }

  function selectScienceButton(button) {
    if (!button || button.disabled || button.classList.contains("sold-out")) return;

    var section = button.closest("[id^='science-section-']");
    if (!section) return;

    var buttons = section.querySelectorAll(".desc-pack-btn");
    var oldAtcBtn = section.querySelector("[id^='scienceAddToCartBtn-']");
    var oldAtcText = section.querySelector("[id*='scienceAddToCartText-']");
    var soldOutText = section.getAttribute("data-sold-out-text") || "Sold Out";

    buttons.forEach(function (btn) {
      btn.classList.remove("selected");
      btn.setAttribute("aria-pressed", "false");
    });

    button.classList.add("selected");
    button.setAttribute("aria-pressed", "true");

    var variantId = button.getAttribute("data-variant-id");
    var available = button.getAttribute("data-available") === "true";

    updatePaymentForm(section, variantId, available);

    if (oldAtcBtn) {
      oldAtcBtn.setAttribute("data-variant-id", variantId);
      oldAtcBtn.disabled = !available;
    }

    if (oldAtcText) {
      oldAtcText.textContent = available ? "Start My Protocol" : soldOutText;
    }
  }

  function selectProtocolPack(item) {
    if (!item || item.classList.contains("sold-out")) return;

    var section = item.closest(".packs-section");
    if (!section) return;

    var items = section.querySelectorAll(".pack-item");
    var oldButton = section.querySelector("[data-pack-cart]");
    var buttonPrefix =
      section.getAttribute("data-button-prefix") ||
      (oldButton ? oldButton.textContent.trim().split("—")[0].trim() : "Start My Protocol");

    items.forEach(function (el) {
      el.classList.remove("selected");
    });

    item.classList.add("selected");

    var variantId = item.getAttribute("data-variant-id");
    var price = item.getAttribute("data-pack-price");
    var available = item.getAttribute("data-available") === "true";

    updatePaymentForm(section, variantId, available);

    if (oldButton) {
      oldButton.setAttribute("data-selected-variant", variantId);
      oldButton.textContent = available ? buttonPrefix + " — " + price : "Sold Out";
      oldButton.disabled = !available;
    }
  }

  function initHeroSections(context) {
    context = context || document;

    context.querySelectorAll(".vitality-hero-v3").forEach(function (section) {
      var selected = section.querySelector(".pack-chip.selected");
      if (selected) selectHeroChip(selected);
    });
  }

  function initScienceSections(context) {
    context = context || document;

    context.querySelectorAll("[id^='science-section-']").forEach(function (section) {
      var selected = section.querySelector(".desc-pack-btn.selected");
      if (selected) selectScienceButton(selected);
    });
  }

  function initProtocolSections(context) {
    context = context || document;

    context.querySelectorAll(".packs-section").forEach(function (section) {
      var selected = section.querySelector(".pack-item.selected");
      if (selected) selectProtocolPack(selected);
    });
  }

  function initRitualPulse() {
    var icons = document.querySelectorAll(".how-icon, .vm-ritual-icon");
    if (!icons.length) return;
    if (document.documentElement.dataset.ritualPulseBound === "true") return;

    document.documentElement.dataset.ritualPulseBound = "true";

    var pulseIdx = 0;

    function pulseCycle() {
      icons.forEach(function (el, i) {
        el.classList.toggle("pulse-active", i === pulseIdx);
      });

      pulseIdx = (pulseIdx + 1) % icons.length;
    }

    pulseCycle();
    setInterval(pulseCycle, 2000);
  }

  function initAll(context) {
    context = context || document;

    initHeroSections(context);
    initScienceSections(context);
    initProtocolSections(context);
    initRitualPulse();
  }

  document.addEventListener("click", function (event) {
    var heroChip = event.target.closest(".vitality-hero-v3 .pack-chip");
    if (heroChip) {
      event.preventDefault();
      selectHeroChip(heroChip);
      return;
    }

    var scienceButton = event.target.closest("[id^='science-section-'] .desc-pack-btn");
    if (scienceButton) {
      event.preventDefault();
      selectScienceButton(scienceButton);
      return;
    }

    var protocolItem = event.target.closest(".packs-section .pack-item");
    if (protocolItem) {
      event.preventDefault();
      selectProtocolPack(protocolItem);
      return;
    }

    var heroCartBtn = event.target.closest("[data-hero-cart]");
    if (heroCartBtn) {
      event.preventDefault();

      var heroSection = heroCartBtn.closest(".vitality-hero-v3");
      var selectedHeroChip = heroSection ? heroSection.querySelector(".pack-chip.selected") : null;
      var heroVariantId =
        heroCartBtn.getAttribute("data-selected-variant") ||
        (selectedHeroChip ? selectedHeroChip.getAttribute("data-variant-id") : "");

      if (!heroVariantId || heroCartBtn.disabled) return;

      heroCartBtn.disabled = true;
      heroCartBtn.classList.add("is-loading");
      heroCartBtn.textContent = "Adding...";

      addVariantToCart(heroVariantId, 1)
        .then(refreshCartCount)
        .then(function () {
          window.location.href = "/cart";
        })
        .catch(function () {
          heroCartBtn.disabled = false;
          heroCartBtn.classList.remove("is-loading");
          heroCartBtn.textContent = "Please try again";
        });

      return;
    }

    var protocolCartBtn = event.target.closest("[data-pack-cart]");
    if (protocolCartBtn) {
      event.preventDefault();

      var protocolVariantId = protocolCartBtn.getAttribute("data-selected-variant");

      if (!protocolVariantId || protocolCartBtn.disabled) return;

      protocolCartBtn.disabled = true;
      protocolCartBtn.classList.add("is-loading");
      protocolCartBtn.textContent = "Adding...";

      addVariantToCart(protocolVariantId, 1)
        .then(refreshCartCount)
        .then(function () {
          window.location.href = "/cart";
        })
        .catch(function () {
          protocolCartBtn.disabled = false;
          protocolCartBtn.classList.remove("is-loading");
          protocolCartBtn.textContent = "Please try again";
        });
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    setTimeout(function () {
      initAll(event.target || document);
    }, 100);
  });

  window.GymVitalitySections = {
    initAll: initAll,
    refreshCartCount: refreshCartCount,
    updatePaymentForm: updatePaymentForm,
    selectHeroChip: selectHeroChip,
    selectScienceButton: selectScienceButton,
    selectProtocolPack: selectProtocolPack
  };
})();